import { create } from 'zustand';
import { AISuggestionAction, AISuggestionState } from './ai-suggestion.type';

const initialState: AISuggestionState = {
  activeAISuggestion: null,
};

export const useAISuggestionStore = create<
  AISuggestionState & AISuggestionAction
>((set) => ({
  ...initialState,
  setActiveAISuggestion: (
    newActiveAISuggestion: AISuggestionState['activeAISuggestion'],
  ) => set({ activeAISuggestion: newActiveAISuggestion }),
}));
